import BrButton from '@govbr/react-components/lib/BrButton';
import { useHistory } from 'react-router-dom';
import _ from 'underscore';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { authLogout, selectGovBr } from '../../auth/authSlice';
import { formatarNumeroFamiliar } from '../../common/formatadores';
import AjudaRapida from '../../components/AjudaRapida/AjudaRapida';
import Card from '../../components/Card/Card';
import MainContainer from '../../components/MainContainer/MainContainer';
import { selectLogado } from '../IdentificacaoPositiva/identificacaoPositivaSlice';
import styles from './Perfil.module.css';
import { selectPerfilCompleto, selectPerfis, selectSituacaoCadastroFamilia} from './perfilSlice';
import { obterNomeDoPerfil } from '../../common/perfilUtils';
import { trackServiceSelect } from '../../common/tracker';

const Perfil: React.FC<any> = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();

  const perfilCompleto = useAppSelector(selectPerfilCompleto);
  const perfis = useAppSelector(selectPerfis);

  const perfil = useAppSelector(selectPerfilCompleto);
  const situacaoCadastroFamilia = useAppSelector(selectSituacaoCadastroFamilia);

  const govBrLogado = useAppSelector(selectGovBr).logado;
  const isAuthenticatedIdPositiva = useAppSelector(selectLogado);

  const voltar = () => {
    //history.replace('/');
    history.replace("/home");
  };

  const logout = () => {
    dispatch(authLogout({ history }));
  };

  const habilitarTrocaPerfil = () => {
    if (!perfis) {
      return false;
    }
    return (
      Object.keys(
        _.groupBy(perfis, function (perfil) {
          return perfil.tipoPerfil.codigo;
        })
      ).length > 1
    );
  };

  const habilitarTrocaFamilia = () => {
    return (
      _.filter(perfis, (perfil) => {
        return perfil.tipoPerfil?.codigo === perfilCompleto?.tipoPerfil?.codigo;
      }).length > 1
    );
  };

  const trocarPerfil = () => {
    history.push({
      pathname: '/selecionarPerfil',
      state: { trocandoPerfil: true },
    });
  };

  const trocarFamilia = async() => {
    history.push({
      pathname: '/selecionarPerfil',
      state: { trocandoFamilia: true },
    });

  };

  const isLogado = () => {
    return (govBrLogado && situacaoCadastroFamilia) || isAuthenticatedIdPositiva
      ? true
      : false;
  }

  const caixaMensagens = () => {
    trackServiceSelect('POR-MENU', "CAIXA DE MENSAGEM");
    history.push('/caixa-mensagem');
  };

  return (
    <MainContainer
      userNav={isLogado()}
      navTitle={obterNomeDoPerfil(perfil, situacaoCadastroFamilia)}
      titleBarraAuxiliar={"Perfil"}
      barraAuxiliar={true}
      navFixed
      stoppedTitle={true}
      navSeparator
      navCaixaMensagens={isLogado() ? caixaMensagens : undefined}
      navLogout={isLogado() ? logout : undefined}>
      <div className={styles.container}>
        <Card>
          <div className={styles.cardTitle}>
            <i className={`fas fa-user-circle ${styles.cardTitleIcon}`}></i>
            <span>{obterNomeDoPerfil(perfilCompleto, situacaoCadastroFamilia)}</span>
          </div>
          {perfilCompleto && (
            <div className={styles.perfilWrapper}>
              <div className={styles.perfil}>
                <div className="flex-column">
                  <span className={styles.title}>Perfil</span>
                  <span>{perfilCompleto.tipoPerfil.nome}</span>
                </div>
                {habilitarTrocaPerfil() && (
                  <i
                    className={`fas fa-exchange-alt ${styles.icon}`}
                    onClick={() => trocarPerfil()}
                  />
                )}
              </div>
              <hr />
              <div className={styles.perfil}>
                <div className="flex-column">
                  <span className={styles.title}>Família</span>
                  <span>{formatarNumeroFamiliar(perfilCompleto.numeroFamiliar)}</span>
                </div>
                {habilitarTrocaFamilia() && (
                  <i
                    className={`fas fa-exchange-alt ${styles.icon}`}
                    onClick={() => trocarFamilia()}
                  />
                )}
              </div>
            </div>
          )}
          <BrButton className={styles.button} onClick={() => voltar()}>
            Voltar para o menu
          </BrButton>
          <BrButton className={`${styles.button} ${styles.secondary}`} onClick={() => logout()}>
            sair do app
          </BrButton>
        </Card>
        <AjudaRapida>
          <div className={styles.textoAjudaRapida}>
            <span>
              <strong>Perfil: </strong>Representa em qual papel você está no cadastro. Pode ser
              Representante Legal (RL), Responsável Familiar (RF) ou integrante familiar.
            </span>
            <br />
            <br />
            <span>
              <strong>Família: </strong>Indica qual família você está verificando os dados.
            </span>
            <br />
            <br />
            {(habilitarTrocaPerfil() || habilitarTrocaFamilia()) && (
              <div className="flex-column">
                <i className={`fas fa-exchange-alt ${styles.trocarIcon}`}></i>
                <span>
                  <strong>Trocar: </strong>Ícone que indica que você pode trocar de perfil ou de
                  família.
                </span>
              </div>
            )}
          </div>
        </AjudaRapida>
      </div>
    </MainContainer>
  );
};

export default Perfil;
